import React, { useEffect, useState } from "react";
import Dashboard from "./dashboard";
import axios from "../api/baseurl";
import "./Spinner.css";
import "./Loader.css";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import UploadLabsCsvFile from "./uploadLabCsvFile";
import CreateLabDetails from "./addLabDetails";
import LabCsvFormat from "./labCsvFormat";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { Pagination } from "react-bootstrap";

function CorporateLabDetails() {
  const [labDetails, setLabDetails] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCsvUplaodModalOpen, setIsCsvUplaodModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
     const [currentPage, setCurrentPage] = useState(0);
     const [totalPages, setTotalPages] = useState(0);
       const [selectedLabCorporate, setSelectedLabCorporate] = useState(null);
     

  const navigate = useNavigate();
  const userid = JSON.parse(localStorage.getItem("data")).userid;

 const token = JSON.parse(localStorage.getItem("data")).token;
 useEffect(() => {
  if (searchTerm.trim()) {
    searchData(0);  
  } else {
    getData(currentPage);   
}
}, [searchTerm]); 
   
     const searchData = async (pageNumber = 0) => {
       setLoader(true);
       try {
        const searchUrl = `/api/labcorporate-labs-mapping/searchLinkedLabs`;
                 const requestData = {
                   searchTerm
                 };
           
         const response = await axios.post(searchUrl, requestData, {
           params: { labCorporateId:selectedLabCorporate.id, page: pageNumber },
           headers: { Authorization: `Bearer ${token}` },
         });
         setLabDetails(response.data.content);
         setCurrentPage(response.data.number);
         setTotalPages(response.data.totalPages);
         setLoader(false);
       } catch (error) {
         setLoader(false);
         handleError(error);
       }
     };
   
     const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
 const corporate = await axios.get(`/api/lab-corporate/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSelectedLabCorporate(corporate.data);

      const response = await axios.get(`/api/labcorporate-labs-mapping/getLinkedLabsByLabCorporateId/labCorporateId=${corporate.data?.id}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabDetails(response.data.content);
      setCurrentPage(response.data.number);
      setTotalPages(response.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }
  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const closeUploadModal = () => {
    setIsCsvUplaodModalOpen(false);
    getData();
  };
  const handleViewLabDetails = (orgcode) => {
    navigate(`/users/corporate-lab-profile/${orgcode}`);
  };

  const [showImageModal, setShowImageModal] = useState(false);

  const handleShowImageModal = () => setShowImageModal(true);
  const handleCloseImageModal = () => setShowImageModal(false);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };
    const renderPageNumbers = () => {
      const pageNumbers = [];
      const maxPageNumbersToShow = 5;
      let startPage = Math.max(0, currentPage - 2);
      let endPage = Math.min(totalPages - 1, currentPage + 2);
  
      if (currentPage <= 2) {
        endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
      }
  
      if (currentPage >= totalPages - 3) {
        startPage = Math.max(0, totalPages - maxPageNumbersToShow);
      }
  
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(
          <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
            {i + 1}
          </Pagination.Item>
        );
      }
      return pageNumbers;
    };

  return (
    <div>
      <div>
        <Dashboard />
      </div>
      <div>
        <div className="col-12 mx-xl-auto ps-xl-10 mt-10">
      
          <div className="card card-raised ">
            
            
            <div className="card-body ">
           
            <div className="card-title form-group d-flex align-items-center justify-content-between">
                <span>Lab Details</span>
                <div className="form-group position-relative" style={{ width: '300px' }}> {/* Adjust width as needed */}
  <input
    type="search"
    className="form-control pl-4"
    placeholder="Search by Lab name or Lab code"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    style={{ paddingLeft: "2rem", width: "100%" }} // Ensure the input takes the full width of the parent div
  />
  <span className="position-absolute" style={{ left: "10px", top: "50%", transform: "translateY(-50%)" }}>
    <FontAwesomeIcon icon={faSearch} />
  </span>
</div>
               
              </div>
             
              <br />
              <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                    <th>Lab Name</th>
                    <th>Lab Code</th>
                    <th>Email</th>
                    <th>Contact Number</th>
                  </tr>
                </thead>
                <tbody>
                {labDetails.length === 0 ? (
                  
            <tr>
               {/* setLoader(false); */}
              <td colSpan="7" className="text-center">
                No Data Available
              </td>
            </tr>
          
          ) : (

                  labDetails.map((accd) => {
                    return (
                      <tr key={accd.name}>
 <td 
  style={{ 
    cursor: 'pointer'
  }}
  onClick={() => handleViewLabDetails(accd.labDetails?.labcode)}
  onMouseOver={(e) => { e.target.style.color = 'blue'; e.target.style.textDecoration = 'underline'; }}
  onMouseOut={(e) => { e.target.style.color = ''; e.target.style.textDecoration = ''; }}
>
  {accd.labDetails.labname}
</td>
                        <td>{accd.labDetails?.labcode}</td>
                        <td>{accd.labDetails?.username}</td>
                        <td>{accd.labDetails?.contact}</td>

                        {/* <td  style={{ cursor: 'pointer' }}>
                          <button className="btn btn-link" onClick={() => handleOrganizationDetailsClick(accd.orgcode,accd.userid,accd.username)}>
                            View Profile
                          </button>
                        </td> */}

                       
                        
                      </tr>
                    );
                  }))}
                </tbody>
              </table>
              <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>
              
              {isModalOpen && (
                  <CreateLabDetails isOpen={isModalOpen} onRequestClose={handleCloseModal} />
                )}
                {isCsvUplaodModalOpen && (
                  <UploadLabsCsvFile isOpen={isCsvUplaodModalOpen} onRequestClose={closeUploadModal} />
                )}

          {showImageModal && (
           <LabCsvFormat isOpen={showImageModal} onRequestClose={handleCloseImageModal} />
           )}
            </div>
          </div>
        </div>
        {loader && <div className="loading"></div>} 
      </div>
    </div>
  );
}

export default CorporateLabDetails;
